import { Component } from '@angular/core'
import { SitesService } from '../../services/sites.service';
import * as _ from 'lodash';
import {
  latLng,
  tileLayer,
  Map,
  polygon
} from 'leaflet';

@Component({
  selector: 'landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})

export class LandingPageComponent {
  title = 'Blah'
  options = {
    layers: [
      tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', { maxZoom: 18, subdomains:['mt0','mt1','mt2','mt3'] })
    ],
    zoom: 6,
    center: latLng(26.72, -89.68)
  };
  layers = [];

  constructor(private sitesService: SitesService) {}

  ngOnInit() {
    this.sitesService.getSites().subscribe(sites => {
      this.layers = _(sites)
        .filter(s => !!s.combined_geometry)
        .map(s => {
          console.log('s', s)
          return polygon(JSON.parse(s.combined_geometry).coordinates);
        })
        .value()
      ;
      console.log('layers', this.layers)
    });
  }

  onMapReady(map: Map) {
    console.log('read');
    setTimeout(() => {
      console.log('time', map)
      map.invalidateSize();
    }, 100);
  }
}